import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getOnlineActiveUser } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import { GetOnlineActiveUserResponse } from '@/modules/dashboard/type'

export default function useQueryGetOnlineActiveUsers(
	props?: UseBaseQueryOptions<GetOnlineActiveUserResponse>,
) {
	return useQuery({
		queryKey: [DashboardKeys.GetOnlineActiveUser],
		queryFn: () => getOnlineActiveUser(),
		...props,
	})
}
